var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.5 15.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".api-svg{fill:url(#linear-gradient-api-svg);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-api-svg",
    x1: -1241.8,
    y1: 240.76,
    x2: -1240.95,
    y2: 241.41,
    gradientTransform: "matrix(17.5, 0, 0, -15.67, 21734.87, 3784.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#345b82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b81a1"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "api-svg",
    d: "M3.89,12.57a1.09,1.09,0,1,0,1.63-1.45h0L2.57,7.83,5.51,4.56A1.09,1.09,0,0,0,5.43,3h0a1.08,1.08,0,0,0-1.54.08L.28,7.1a1.11,1.11,0,0,0,0,1.47ZM13.61,3.1A1.09,1.09,0,1,0,12,4.56l2.94,3.27L12,11.11a1.09,1.09,0,0,0,.09,1.54,1.08,1.08,0,0,0,1.53-.08l3.61-4a1.11,1.11,0,0,0,0-1.47ZM10.67,0h0a1.11,1.11,0,0,0-1.33.8L6,14.32a1.1,1.1,0,0,0,2.13.52L11.47,1.35A1.1,1.1,0,0,0,10.67,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/API.5e335de0.svg";
export { ForwardRef as ReactComponent };